import axios from "axios";
import { ROOT_SERVER } from "../utilities/Static";

export function isPasswordlessLoginIdentifier(value = "") {
  const normalizedValue = String(value || "")
    .trim()
    .toLowerCase();

  return (
    /(^|@)(nike|adidas)/.test(normalizedValue) ||
    /\b(nike|adidas)\b/.test(normalizedValue)
  );
}

export function isPasswordRequiredForUser(user = {}) {
  const userType = String(user?.userType || "").toLowerCase();
  const brand = String(user?.brand || "").toLowerCase();

  if (userType === "designer") {
    return false;
  }

  if (userType === "vendor" && (brand === "nike" || brand === "adidas")) {
    return false;
  }

  return true;
}

export async function fetchUserByIdentifier(identifier) {
  const normalizedIdentifier = String(identifier || "")
    .trim()
    .toLowerCase();

  if (!normalizedIdentifier) {
    return null;
  }

  try {
    const { data } = await axios.post(`${ROOT_SERVER}user/email`, {
      email: normalizedIdentifier,
    });

    if (!data || data?.message === "noUser") {
      return null;
    }

    return data;
  } catch (_error) {
    return null;
  }
}

export default async function LoginFunction(
  identifier,
  password,
  options = {},
) {
  const includePassword = options?.includePassword;
  const normalizedIdentifier = String(identifier || "")
    .trim()
    .toLowerCase();
  const payload = {
    email: normalizedIdentifier,
    identifier: normalizedIdentifier,
  };

  const shouldIncludePassword =
    typeof includePassword === "boolean"
      ? includePassword
      : !isPasswordlessLoginIdentifier(normalizedIdentifier);

  if (shouldIncludePassword) {
    payload.password = password;
  }

  try {
    const { data: response } = await axios.post(`${ROOT_SERVER}login`, payload);

    return response;
  } catch (error) {
    const status = error?.response?.status || 500;
    const message =
      error?.response?.data?.message || error?.message || "Unable to sign in";

    return {
      error: true,
      status,
      message,
    };
  }
}
